import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

import { AdminLayoutComponent } from './layout/admin-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          )
      },
      {
        path: 'email-logs',
        loadComponent: () =>
          import('./pages/email-logs/email-logs.component').then(
            (m) => m.EmailLogsComponent
          )
      },
      {
        path: 'audit-logs',
        loadComponent: () =>
          import('./pages/audit-logs/audit-logs.component').then(
            (m) => m.AuditLogsComponent
          )
      },
      {
        path: 'courses',
        loadComponent: () =>
          import('./pages/courses/course-list/course-list.component').then(
            (m) => m.CourseListComponent
          )
      },
      {
        path: 'courses/:id/syllabus',
        loadComponent: () =>
          import('./pages/courses/course-syllabus/course-syllabus.component').then(
            (m) => m.CourseSyllabusComponent
          )
      },
      {
        path: 'courses/:id/students',
        loadComponent: () =>
          import('./pages/courses/course-student-management/course-student-management.component').then(
            (m) => m.CourseStudentManagementComponent
          )
      },
      {
        path: 'courses/:courseId/sections/:sectionId/videos',
        loadComponent: () =>
          import('./pages/courses/section-videos/section-videos.component').then(
            (m) => m.SectionVideosComponent
          )
      },
      {
        path: 'students',
        loadComponent: () =>
          import('./pages/students/student-list/student-list.component').then(
            (m) => m.StudentListComponent
          )
      },
      {
        path: 'enrollment-orders',
        loadComponent: () =>
          import('./pages/enrollment-orders/enrollment-orders.component').then(
            (m) => m.EnrollmentOrdersComponent
          )
      },
      {
        path: 'system-management',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/system-management/system-management-hub/system-management-hub.component').then(
                (m) => m.SystemManagementHubComponent
              )
          },
          {
            path: 'content',
            loadComponent: () =>
              import('./pages/system-management/system-management.component').then(
                (m) => m.SystemManagementComponent
              )
          },
          {
            path: 'general',
            loadComponent: () =>
              import('./pages/system-management/general-settings/general-settings.component').then(
                (m) => m.GeneralSettingsComponent
              )
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import('./pages/system-management/notification-settings/notification-settings.component').then(
                (m) => m.NotificationSettingsComponent
              )
          },
          {
            path: 'maintenance',
            loadComponent: () =>
              import('./pages/system-management/maintenance-settings/maintenance-settings.component').then(
                (m) => m.MaintenanceSettingsComponent
              )
          }
        ]
      },
      {
        path: 'bug-reports',
        loadComponent: () =>
          import('./pages/bug-reports/bug-reports.component').then(
            (m) => m.BugReportsComponent
          )
      },
      {
        path: 'videos',
        loadComponent: () =>
          import('./pages/videos/video-list/video-list.component').then(
            (m) => m.VideoListComponent
          )
      },
      {
        path: 'profile',
        redirectTo: '/system-management/general',
        pathMatch: 'full'
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('./pages/invoices/invoices.component').then(
            (m) => m.InvoicesComponent
          )
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
